/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react'
import { useRouter } from 'next/router'
import Image from 'next/image'
import Plus from '../../../public/images/plus-new.svg'
import { Header1, Header3, Text } from '../../styles/Components'
import GiftInput from '../gift-input'
import HeroImage from '../../../public/gift-cards/GS_gift_card_hero.jpeg'

const Hero = () => {
  const [mobileOpen, setMobileOpen] = useState(false)
  const history = useRouter()

  const toggleMobile = () => setMobileOpen((m) => !m)

  const onSuccess = () => history.push('/account/credits')

  return (
    <div className="gift-card-hero-container">
      <div className="hero-container-inner">
        <div className="content">
          <div className="inner">
            <Header1 margin="0 0 28px 0">GIVE THE GIFT OF GLAM</Header1>
            <Text fontSize={22} color="#FFF" lineHeight="138%">
              Spoil the ones you love with professional glam on demand.
              They&apos;ll pick the time and place — and we&apos;ll come to
              pamper.
            </Text>
          </div>
        </div>
        <div className="image-placeholder">
          <Image
            src={HeroImage}
            alt='Glamsquad gift card'
            style={{ objectFit: 'cover' }}
            fill
            priority
          />
        </div>
      </div>
      <div className="gift-input-container">
        <Header3 margin="0 29px 0 0">Are you a gift recipient?</Header3>
        <GiftInput {...{ onSuccess }} />
      </div>
      <div className="mobile-gift-input-container">
        <button className="mobile-gift-input-button" onClick={toggleMobile}>
          <Header3 margin="0 29px 0 0">Are you a gift recipient?</Header3>
          <Image src={Plus} alt="plus icon" />
        </button>
        {mobileOpen && (
          <div className="mobile-input-display">
            <GiftInput {...{ onSuccess }} />
          </div>
        )}
      </div>
    </div>
  )
}

export default Hero
